import { render, staticRenderFns } from "./divvyAdminSalesTaxList.vue?vue&type=template&id=05f10d03&"
import script from "./divvyAdminSalesTaxList.vue?vue&type=script&lang=js&"
export * from "./divvyAdminSalesTaxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports